function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _c;
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var t;
t = {
  config: {},
  run: function run() {
    return this.getController().processElements();
  },
  process: function process() {
    var e, r, a;
    for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
      t[_key] = arguments[_key];
    }
    for (r = 0, a = t.length; r < a; r++) e = t[r], this.getController().processElement(e);
    return t.length;
  },
  getController: function getController() {
    return null != this.controller ? this.controller : this.controller = new t.Controller();
  }
};
var e,
  r,
  a,
  n,
  s,
  i,
  o,
  u,
  l,
  c,
  d,
  m,
  h,
  f,
  g,
  p,
  S,
  v,
  y,
  _T,
  b,
  M,
  D,
  w,
  E,
  I,
  C,
  N,
  A,
  O,
  $,
  F,
  Y,
  k,
  W,
  L = t;
L.config.useFormat24 = !1, L.config.i18n = {
  en: {
    date: {
      dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      abbrDayNames: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      abbrMonthNames: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      yesterday: "yesterday",
      today: "today",
      tomorrow: "tomorrow",
      on: "on {date}",
      formats: {
        "default": "%b %e, %Y",
        thisYear: "%b %e"
      }
    },
    time: {
      am: "am",
      pm: "pm",
      singular: "a {time}",
      singularAn: "an {time}",
      elapsed: "{time} ago",
      second: "second",
      seconds: "seconds",
      minute: "minute",
      minutes: "minutes",
      hour: "hour",
      hours: "hours",
      formats: {
        "default": "%l:%M%P",
        default_24h: "%H:%M"
      }
    },
    datetime: {
      at: "{date} at {time}",
      formats: {
        "default": "%B %e, %Y at %l:%M%P %Z",
        default_24h: "%B %e, %Y at %H:%M %Z"
      }
    }
  }
}, L.config.locale = "en", L.config.defaultLocale = "en", L.config.timerInterval = 6e4, a = !isNaN(Date.parse("2011-01-01T12:00:00-05:00")), L.parseDate = function (t) {
  return t = t.toString(), a || (t = r(t)), new Date(Date.parse(t));
}, e = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(Z|[-+]?[\d:]+)$/, r = function r(t) {
  var _s, _s2;
  var r, a, n, s, i, o, u, l, c, d;
  if (s = t.match(e)) return (_s = s, _s2 = _slicedToArray(_s, 8), r = _s2[0], c = _s2[1], o = _s2[2], a = _s2[3], n = _s2[4], i = _s2[5], l = _s2[6], d = _s2[7]), "Z" !== d && (u = d.replace(":", "")), "".concat(c, "/").concat(o, "/").concat(a, " ").concat(n, ":").concat(i, ":").concat(l, " GMT").concat([u]);
}, L.elementMatchesSelector = (n = document.documentElement, s = null != (i = null != (o = null != (u = null != (l = n.matches) ? l : n.matchesSelector) ? u : n.webkitMatchesSelector) ? o : n.mozMatchesSelector) ? i : n.msMatchesSelector, function (t, e) {
  if ((null != t ? t.nodeType : void 0) === Node.ELEMENT_NODE) return s.call(t, e);
}), c = L.config, (_c = c, m = _c.i18n), L.getI18nValue = function () {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      locale: c.locale
    },
    e = _ref.locale;
  var r;
  return null != (r = d(m[e], t)) ? r : e !== c.defaultLocale ? L.getI18nValue(t, {
    locale: c.defaultLocale
  }) : void 0;
}, L.translate = function (t) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var r = arguments.length > 2 ? arguments[2] : undefined;
  var a, n, s;
  for (a in s = L.getI18nValue(t, r), e) n = e[a], s = s.replace("{".concat(a, "}"), n);
  return s;
}, d = function d(t, e) {
  var r, a, n, s, i;
  for (i = t, r = 0, n = (s = e.split(".")).length; r < n; r++) {
    if (null == i[a = s[r]]) return null;
    i = i[a];
  }
  return i;
}, (f = L.getI18nValue, M = L.translate), b = "function" == typeof ("undefined" != typeof Intl && null !== Intl ? Intl.DateTimeFormat : void 0), g = {
  "Central European Standard Time": "CET",
  "Central European Summer Time": "CEST",
  "China Standard Time": "CST",
  "Israel Daylight Time": "IDT",
  "Israel Standard Time": "IST",
  "Moscow Standard Time": "MSK",
  "Philippine Standard Time": "PHT",
  "Singapore Standard Time": "SGT",
  "Western Indonesia Time": "WIB"
}, L.knownEdgeCaseTimeZones = g, L.strftime = _T = function T(t, e) {
  var r, a, n, s, i, o, u;
  return a = t.getDay(), r = t.getDate(), i = t.getMonth(), u = t.getFullYear(), n = t.getHours(), s = t.getMinutes(), o = t.getSeconds(), e.replace(/%(-?)([%aAbBcdeHIlmMpPSwyYZ])/g, function (e, l, c) {
    switch (c) {
      case "%":
        return "%";
      case "a":
        return f("date.abbrDayNames")[a];
      case "A":
        return f("date.dayNames")[a];
      case "b":
        return f("date.abbrMonthNames")[i];
      case "B":
        return f("date.monthNames")[i];
      case "c":
        return t.toString();
      case "d":
        return p(r, l);
      case "e":
        return r;
      case "H":
        return p(n, l);
      case "I":
        return p(_T(t, "%l"), l);
      case "l":
        return 0 === n || 12 === n ? 12 : (n + 12) % 12;
      case "m":
        return p(i + 1, l);
      case "M":
        return p(s, l);
      case "p":
        return M("time." + (n > 11 ? "pm" : "am")).toUpperCase();
      case "P":
        return M("time." + (n > 11 ? "pm" : "am"));
      case "S":
        return p(o, l);
      case "w":
        return a;
      case "y":
        return p(u % 100, l);
      case "Y":
        return u;
      case "Z":
        return S(t);
    }
  });
}, p = function p(t, e) {
  return "-" === e ? t : "0".concat(t).slice(-2);
}, S = function S(t) {
  var e, r, a;
  return (r = h(t)) ? g[r] : (a = y(t, {
    allowGMT: !1
  })) || (a = v(t)) ? a : (e = y(t, {
    allowGMT: !0
  })) ? e : "";
}, h = function h(t) {
  return Object.keys(g).find(function (e) {
    return b ? new Date(t).toLocaleString("en-US", {
      timeZoneName: "long"
    }).includes(e) : t.toString().includes(e);
  });
}, y = function y(t, _ref2) {
  var e = _ref2.allowGMT;
  var r;
  if (b && (r = new Date(t).toLocaleString("en-US", {
    timeZoneName: "short"
  }).split(" ").pop(), e || !r.includes("GMT"))) return r;
}, v = function v(t) {
  var e, r, a, n, s;
  return (e = null != (r = (s = t.toString()).match(/\(([\w\s]+)\)$/)) ? r[1] : void 0) ? /\s/.test(e) ? e.match(/\b(\w)/g).join("") : e : (e = null != (a = s.match(/(\w{3,4})\s\d{4}$/)) ? a[1] : void 0) || (e = null != (n = s.match(/(UTC[\+\-]\d+)/)) ? n[1] : void 0) ? e : void 0;
}, L.CalendarDate = /*#__PURE__*/function () {
  function _class(t, e, r) {
    _classCallCheck(this, _class);
    this.date = new Date(Date.UTC(t, e - 1)), this.date.setUTCDate(r), this.year = this.date.getUTCFullYear(), this.month = this.date.getUTCMonth() + 1, this.day = this.date.getUTCDate(), this.value = this.date.getTime();
  }
  _createClass(_class, [{
    key: "equals",
    value: function equals(t) {
      return (null != t ? t.value : void 0) === this.value;
    }
  }, {
    key: "is",
    value: function is(t) {
      return this.equals(t);
    }
  }, {
    key: "isToday",
    value: function isToday() {
      return this.is(this.constructor.today());
    }
  }, {
    key: "occursOnSameYearAs",
    value: function occursOnSameYearAs(t) {
      return this.year === (null != t ? t.year : void 0);
    }
  }, {
    key: "occursThisYear",
    value: function occursThisYear() {
      return this.occursOnSameYearAs(this.constructor.today());
    }
  }, {
    key: "daysSince",
    value: function daysSince(t) {
      if (t) return (this.date - t.date) / 864e5;
    }
  }, {
    key: "daysPassed",
    value: function daysPassed() {
      return this.constructor.today().daysSince(this);
    }
  }], [{
    key: "fromDate",
    value: function fromDate(t) {
      return new this(t.getFullYear(), t.getMonth() + 1, t.getDate());
    }
  }, {
    key: "today",
    value: function today() {
      return this.fromDate(new Date());
    }
  }]);
  return _class;
}(), (E = L.strftime, I = L.translate, w = L.getI18nValue, D = L.config), L.RelativeTime = /*#__PURE__*/function () {
  function _class2(t) {
    _classCallCheck(this, _class2);
    this.date = t, this.calendarDate = L.CalendarDate.fromDate(this.date);
  }
  _createClass(_class2, [{
    key: "toString",
    value: function toString() {
      var t, e;
      return (e = this.toTimeElapsedString()) ? I("time.elapsed", {
        time: e
      }) : (t = this.toWeekdayString()) ? (e = this.toTimeString(), I("datetime.at", {
        date: t,
        time: e
      })) : I("date.on", {
        date: this.toDateString()
      });
    }
  }, {
    key: "toTimeOrDateString",
    value: function toTimeOrDateString() {
      return this.calendarDate.isToday() ? this.toTimeString() : this.toDateString();
    }
  }, {
    key: "toTimeElapsedString",
    value: function toTimeElapsedString() {
      var t, e, r, a, n;
      return r = new Date().getTime() - this.date.getTime(), a = Math.round(r / 1e3), e = Math.round(a / 60), t = Math.round(e / 60), r < 0 ? null : a < 10 ? (n = I("time.second"), I("time.singular", {
        time: n
      })) : a < 45 ? "".concat(a, " ").concat(I("time.seconds")) : a < 90 ? (n = I("time.minute"), I("time.singular", {
        time: n
      })) : e < 45 ? "".concat(e, " ").concat(I("time.minutes")) : e < 90 ? (n = I("time.hour"), I("time.singularAn", {
        time: n
      })) : t < 24 ? "".concat(t, " ").concat(I("time.hours")) : "";
    }
  }, {
    key: "toWeekdayString",
    value: function toWeekdayString() {
      switch (this.calendarDate.daysPassed()) {
        case 0:
          return I("date.today");
        case 1:
          return I("date.yesterday");
        case -1:
          return I("date.tomorrow");
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
          return E(this.date, "%A");
        default:
          return "";
      }
    }
  }, {
    key: "toDateString",
    value: function toDateString() {
      var t;
      return t = this.calendarDate.occursThisYear() ? w("date.formats.thisYear") : w("date.formats.default"), E(this.date, t);
    }
  }, {
    key: "toTimeString",
    value: function toTimeString() {
      var t;
      return t = D.useFormat24 ? "default_24h" : "default", E(this.date, w("time.formats.".concat(t)));
    }
  }]);
  return _class2;
}(), C = L.elementMatchesSelector, L.PageObserver = /*#__PURE__*/function () {
  function _class3(t, e) {
    _classCallCheck(this, _class3);
    this.processMutations = this.processMutations.bind(this), this.processInsertion = this.processInsertion.bind(this), this.selector = t, this.callback = e;
  }
  _createClass(_class3, [{
    key: "start",
    value: function start() {
      if (!this.started) return this.observeWithMutationObserver() || this.observeWithMutationEvent(), this.started = !0;
    }
  }, {
    key: "observeWithMutationObserver",
    value: function observeWithMutationObserver() {
      if ("undefined" != typeof MutationObserver && null !== MutationObserver) return new MutationObserver(this.processMutations).observe(document.documentElement, {
        childList: !0,
        subtree: !0
      }), !0;
    }
  }, {
    key: "observeWithMutationEvent",
    value: function observeWithMutationEvent() {
      return addEventListener("DOMNodeInserted", this.processInsertion, !1), !0;
    }
  }, {
    key: "findSignificantElements",
    value: function findSignificantElements(t) {
      var _e;
      var e;
      return e = [], (null != t ? t.nodeType : void 0) === Node.ELEMENT_NODE && (C(t, this.selector) && e.push(t), (_e = e).push.apply(_e, _toConsumableArray(t.querySelectorAll(this.selector)))), e;
    }
  }, {
    key: "processMutations",
    value: function processMutations(t) {
      var e, r, a, n, s, i, o, u;
      for (e = [], r = 0, n = t.length; r < n; r++) if ("childList" === (i = t[r]).type) for (a = 0, s = (u = i.addedNodes).length; a < s; a++) {
        var _e2;
        o = u[a], (_e2 = e).push.apply(_e2, _toConsumableArray(this.findSignificantElements(o)));
      }
      return this.notify(e);
    }
  }, {
    key: "processInsertion",
    value: function processInsertion(t) {
      var e;
      return e = this.findSignificantElements(t.target), this.notify(e);
    }
  }, {
    key: "notify",
    value: function notify(t) {
      if (null != t ? t.length : void 0) return "function" == typeof this.callback ? this.callback(t) : void 0;
    }
  }]);
  return _class3;
}(), (O = L.parseDate, $ = L.strftime, A = L.getI18nValue, N = L.config), L.Controller = function () {
  var t, e, r, a;
  return t = "time[data-local]:not([data-localized])", e = function e(t) {
    return t.setAttribute("data-localized", "");
  }, r = function r(t) {
    return t.setAttribute("data-processed-at", new Date().toISOString());
  }, a = function a(t) {
    return new L.RelativeTime(t);
  }, /*#__PURE__*/function () {
    function _class4() {
      _classCallCheck(this, _class4);
      this.processElements = this.processElements.bind(this), this.pageObserver = new L.PageObserver(t, this.processElements);
    }
    _createClass(_class4, [{
      key: "start",
      value: function start() {
        if (!this.started) return this.processElements(), this.startTimer(), this.pageObserver.start(), this.started = !0;
      }
    }, {
      key: "startTimer",
      value: function startTimer() {
        var t;
        if (t = N.timerInterval) return null != this.timer ? this.timer : this.timer = setInterval(this.processElements, t);
      }
    }, {
      key: "processElements",
      value: function processElements() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.querySelectorAll(t);
        var r, a, n;
        for (a = 0, n = e.length; a < n; a++) r = e[a], this.processElement(r);
        return e.length;
      }
    }, {
      key: "processElement",
      value: function processElement(t) {
        var n, s, i, o, u, l;
        if (n = t.getAttribute("datetime"), i = t.getAttribute("data-local"), s = N.useFormat24 && t.getAttribute("data-format24") || t.getAttribute("data-format"), o = O(n), !isNaN(o)) return t.hasAttribute("title") || (l = N.useFormat24 ? "default_24h" : "default", u = $(o, A("datetime.formats.".concat(l))), t.setAttribute("title", u)), r(t), t.textContent = function () {
          switch (i) {
            case "time":
              return e(t), $(o, s);
            case "date":
              return e(t), a(o).toDateString();
            case "time-ago":
              return a(o).toString();
            case "time-or-date":
              return a(o).toTimeOrDateString();
            case "weekday":
              return a(o).toWeekdayString();
            case "weekday-or-date":
              return a(o).toWeekdayString() || a(o).toDateString();
          }
        }();
      }
    }]);
    return _class4;
  }();
}.call(window), W = !1, F = function F() {
  return document.attachEvent ? "complete" === document.readyState : "loading" !== document.readyState;
}, Y = function Y(t) {
  var e;
  return null != (e = "function" == typeof requestAnimationFrame ? requestAnimationFrame(t) : void 0) ? e : setTimeout(t, 17);
}, k = function k() {
  return L.getController().start();
}, L.start = function () {
  return W ? L.run() : (W = !0, "undefined" != typeof MutationObserver && null !== MutationObserver || F() ? k() : Y(k));
}, L.processing = function () {
  return L.getController().started;
}, window.LocalTime === L && L.start();
export { L as default };